// Constants shared between domains like package + hotels or package + flights

export const DEFAULT_ROOMS = [
  {
    adults: 2,
    childrenAge: [],
  },
];
